import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PackagePlus, ScanLine, Boxes, Scale, Truck, ArrowRight } from "lucide-react";
import { wmsApi, fmtKg2 } from "./wmsApi";
import { WCard } from "./WmsUi";

const Tile = ({ onClick, className = "", children, testId }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className={`text-left border-2 border-zinc-900 bg-white p-5 md:p-6 hover:-translate-y-1 hover:shadow-[6px_6px_0px_#09090b] active:translate-y-0 active:shadow-none transition-transform min-h-[120px] ${className}`}
  >
    {children}
  </button>
);

export default function WmsDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    wmsApi.get("/wms/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-['Chivo'] font-black text-3xl md:text-4xl tracking-tighter text-zinc-900 uppercase">Centro di controllo</h1>
        <p className="text-zinc-500 mt-1">Ricevimento merci · etichettatura · tracciabilità</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[
          { label: "Kg entrati oggi", value: fmtKg2(stats?.kg_in_today) },
          { label: "Pezzi etichettati oggi", value: stats?.pieces_today ?? "—" },
          { label: "Giacenza totale kg", value: fmtKg2(stats?.stock_kg) },
          { label: "Carichi aperti", value: stats?.receipts_open ?? "—" },
        ].map((k) => (
          <WCard key={k.label} className="p-4">
            <p className="font-['Chivo'] font-black text-2xl md:text-3xl text-zinc-900">{k.value}</p>
            <p className="text-[11px] uppercase tracking-[0.15em] font-bold text-zinc-500 mt-1">{k.label}</p>
          </WCard>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <Tile onClick={() => navigate("/wms/carichi?new=1")} testId="tile-nuovo-carico" className="md:col-span-2 !bg-[#FF4500] !border-[#FF4500] text-white">
          <PackagePlus className="w-10 h-10 mb-3" />
          <p className="font-['Chivo'] font-black text-2xl md:text-3xl uppercase tracking-tight">Nuovo carico</p>
          <p className="text-orange-100 mt-1 flex items-center gap-2 text-sm font-semibold">Ricevimento merce da fornitore <ArrowRight className="w-4 h-4" /></p>
        </Tile>
        <Tile onClick={() => navigate("/wms/scan")} testId="tile-scan">
          <ScanLine className="w-9 h-9 mb-3 text-[#FF4500]" />
          <p className="font-['Chivo'] font-black text-xl uppercase">Scansiona</p>
          <p className="text-zinc-500 text-sm mt-1">Leggi etichetta · ristampa · modifica</p>
        </Tile>
        <Tile onClick={() => navigate("/wms/giacenze")} testId="tile-giacenze">
          <Boxes className="w-9 h-9 mb-3 text-[#FF4500]" />
          <p className="font-['Chivo'] font-black text-xl uppercase">Giacenze</p>
          <p className="text-zinc-500 text-sm mt-1">{stats ? `${stats.stock_pieces} pezzi · ${fmtKg2(stats.stock_kg)} kg` : "—"}</p>
        </Tile>
        <Tile onClick={() => navigate("/wms/carichi")} testId="tile-carichi">
          <PackagePlus className="w-9 h-9 mb-3 text-zinc-900" />
          <p className="font-['Chivo'] font-black text-xl uppercase">Carichi</p>
          <p className="text-zinc-500 text-sm mt-1">{stats ? `${stats.receipts_open} aperti` : "—"} · storico bolle</p>
        </Tile>
        <Tile onClick={() => navigate("/wms/bilancio")} testId="tile-bilancio">
          <Scale className="w-9 h-9 mb-3 text-zinc-900" />
          <p className="font-['Chivo'] font-black text-xl uppercase">Bilancio di massa</p>
          <p className="text-zinc-500 text-sm mt-1">IN − OUT − Giacenza = 0</p>
        </Tile>
        <Tile onClick={() => navigate("/wms/fornitori")} testId="tile-fornitori">
          <Truck className="w-9 h-9 mb-3 text-zinc-900" />
          <p className="font-['Chivo'] font-black text-xl uppercase">Fornitori</p>
          <p className="text-zinc-500 text-sm mt-1">Codici prodotto · ultimi prezzi</p>
        </Tile>
      </div>
    </div>
  );
}
